import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import Icon from '../../../base/icons/components/Icon';
import { IconDimming } from '../../../base/icons/svg';
import { inklusivaContextMenuStyles } from '../../../inklusiva/ui-constants';
import { OPACITY_SLIDER_MAXIMUM, OPACITY_SLIDER_MINIMUM } from '../../constants';
const useStyles = makeStyles()(theme => {
    return {
        ...inklusivaContextMenuStyles(theme)
    };
});
const _onClick = (e) => {
    e.stopPropagation();
};
const OpacityAdjustSlider = ({ initialValue, label, onChange }) => {
    const { classes, cx } = useStyles();
    const { t } = useTranslation();
    const [opacity, setOpacity] = useState(initialValue);
    const _onFrequencyAdjustChange = useCallback((event) => {
        const newOpacity = event.currentTarget.value;
        onChange(newOpacity);
        setOpacity(Number(newOpacity));
    }, [onChange]);
    return (React.createElement("div", { "aria-label": t('opacityAdjustSlider'), className: classes.contextMenuSlider },
        React.createElement("label", { className: classes.contextMenuSliderLabel, htmlFor: 'opacity-slider-input' }, label),
        React.createElement("div", { className: cx('popupmenu__contents', classes.contextMenuSliderInner), onClick: _onClick },
            React.createElement("span", { className: classes.contextMenuSliderIcon },
                React.createElement(Icon, { size: 22, src: IconDimming })),
            React.createElement("input", { "aria-label": label, id: 'opacity-slider-input', "aria-valuemax": OPACITY_SLIDER_MAXIMUM, "aria-valuemin": OPACITY_SLIDER_MINIMUM, "aria-valuenow": opacity, max: OPACITY_SLIDER_MAXIMUM, min: OPACITY_SLIDER_MINIMUM, onChange: _onFrequencyAdjustChange, tabIndex: 0, type: 'range', value: opacity }))));
};
export default OpacityAdjustSlider;
